importScripts("https://www.gstatic.com/firebasejs/10.12.1/firebase-app-compat.js");
importScripts("https://www.gstatic.com/firebasejs/10.12.1/firebase-messaging-compat.js");

firebase.initializeApp({
  apiKey: "AIzaSyBz1_9qhsrb5_TkBJoIOID8Kwavoxh8GSs",
  authDomain: "mobitrix-android.firebaseapp.com",
  projectId: "mobitrix-android",
  messagingSenderId: "914093533371",
  appId: "1:914093533371:web:de9ca1a48bc3027c1c619e"
});

const messaging = firebase.messaging();
var Audio;
var useState;
// function initializeFirebase() {
//   var firebaseConfig = {
//     apiKey: "AIzaSyBz1_9qhsrb5_TkBJoIOID8Kwavoxh8GSs",
//     authDomain: "mobitrix-android.firebaseapp.com",
//     databaseURL: "https://mobitrix-android.firebaseio.com",
//     projectId: "mobitrix-android",
//     storageBucket: "mobitrix-android.firebasestorage.app",
//     messagingSenderId: "914093533371",
//     appId: "1:914093533371:web:fc37de81c3d148c41c619e",
//     measurementId: "G-TMTH4L9JJK",
//     vapId: "BET6lTRjK9Rtta9isHCIok6qF3mPlMrbrS-XQfAOsm2XDOxN5-3ZXN5luYhGOGxQtFgkKzVJXtvaGkGLsd0GvbU",
//   };
//   // Initialize Firebase
//   if (firebase.messaging.isSupported()) {
//     var firebaseApp = firebase.initializeApp(firebaseConfig);
//     var messaging = firebase.messaging();
//     messaging.onBackgroundMessage(function (payload) {

//       //payload.notification.body="You Are Welcome"
//       console.log("Received background Full Notification == ", payload);
//       // console.log("Received background notif== ", payload.notification);
//       // console.log("Received background forModule== ", payload.data.forModule);
//       // console.log("Received background refNo== ", payload.data.refNo);
//       // console.log("Received background Beep== ", payload.data.beep);
//       // console.log("Received background readMessage== ", payload.data.readMessage);
//       console.log("Received background Data== ", payload.data);
//       console.log("Received background title== ", payload.notification.title);
//       console.log("Received background Body== ", payload.notification.body);
//       // if (payload.data.forModule == "Web Order") {
//       //   // const channel=new BroadcastChannel('bg-notification')
//       //   // channel.postMessage(payload)
//       // }
//       let messageBody = payload.data?.messageBody || 'New message received'; // Directly use messageBody

//       console.log('Raw messageBody:', messageBody);

//       // Extract the first part of messageBody before "==="
//       const cleanMessageBody = messageBody.split("===")[0]?.trim();
//       console.log("Clean MessageBody:", cleanMessageBody);

//       // Convert message to user-friendly text
//       const userFriendlyMessage = convertToUserFriendlyMessage(cleanMessageBody);

//       console.log("Final Heading Message:", userFriendlyMessage);

//       // Modify notification body
//       const notificationTitle = payload.notification?.title || "New Notification";
//       const notificationOptions = {
//         body: userFriendlyMessage,
//         icon: "/firebase-logo.png",
//       };


//       const channel = new BroadcastChannel("bg-notification");
//       channel.postMessage({ payload: payload, url: "urls" });

//       return self.registration.showNotification(notificationTitle,
//         notificationOptions);
//     });
//   } else {
//     return;
//   }

// self.addEventListener('push', function(event) {
//     event.waitUntil(self.registration.showNotification('Message Received1'));
// });


messaging.onBackgroundMessage(function (payload) {
  console.log("Background message: ", payload);

  const notificationTitle = payload.notification?.title;
  const notificationOptions = {
    body: payload.notification?.body,
    icon: "/firebase-logo.png"
  };

  self.registration.showNotification(notificationTitle, notificationOptions);
});


// Convert extracted messageBody to a user-friendly message
function convertToUserFriendlyMessage(messageBody) {
  switch (messageBody.trim()) {
    case "Web Order Placed":
      return "New order received, accept now to start processing.";
    case "Web Order Accepted":
      return "New web order accepted, now ready for processing.";
    case "Delivery pending1, Assign to any rider":
      return "Reminder: Your order delivery is in 2 hours. Prepare for pickup.";
    case "Delivery pending2, Assign to any rider":
      return "60-minute delay warning. Prepare your order quickly.";
    case "Delivery pending3, Assign to any rider":
      return "Critical delay warning. Only 30 minutes left for delivery.";
    case 'Customized Order':
      return 'New customized order requested, please accept to start processing.';
    case 'Customized Order Accepted':
      return 'Customized order accepted, now ready for processing.';
    case 'Web Order Rescheduled':
      return 'Web order has been rescheduled. Please check the updated details.';
    case 'Web Order Cancelled':
      return 'Web order has been cancelled. Please review the cancellation details.';
      break;
    default:
      return "You have a new notification.";
  }
}

